import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getLohriInfo = createAsyncThunk(
  'Lohri/getLohriInfo',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/sun_god_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const getReward = createAsyncThunk(
  'Lohri/getReward',
  // 1: 房主头框；
  // 2: 房间头框
  async (p: {award_type: 1 | 2}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/sun_god_get_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
interface itemProp {
  member_info: any
  rank: number
  score: number
}
const initialState: {
  list: Array<itemProp>
  stage_id: 1 | 2 | 3 // （1为资格赛，2为半决赛，3为决赛）
  own: itemProp
  progress_max: Array<number> // [300, 3000] 两个阶段的目标值
  coins: number
  count_down: number
  reward_one_status: 0 | 1 | 2 // 0未完成， 1已完成， 2已领取
  reward_two_status: 0 | 1 | 2 // 0 未完成， 2待下发 奖励2不能手动领
} = {
  list: [],
  own: {
    member_info: {},
    rank: 0,
    score: 0,
  },
  stage_id: 1,
  progress_max: [300, 3000], // [300, 3000] 两个阶段的目标值
  coins: 0,
  count_down: 0,
  reward_one_status: 0, // 0未完成， 1已完成， 2已领取
  reward_two_status: 0, // 0 未完成， 2待下发 奖励2不能手动领
}

export const LohriSlice = createSlice({
  name: 'Lohri',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLohriInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})
export default LohriSlice.reducer
